// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="stopProcessHeader">Unable to Process Payment</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="stopProcessBody">Unfortunately, we are unable to accept a payment for the Property IDs entered. Please contact your property management company. {{ data.reasonCode }}</p>
        </div>
        <div class="u-mB9"><a (click)="openUrl(data.contactUrl)" tid="contactLink">Contact {{data.pmcName}}</a></div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" tid="stopProcessClose" (click)="closeThisDialog(0)">Close</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;